export default {"src":"/_next/static/media/ShoulderImpingement.a3d023a0.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};